import { CATEGORY_TREE_ROOT_PATHS, SHOP_TREE_ROOT_PATH, getTopicType, } from "@cappelendamm/crystallize-utils";
export { CATEGORY_TREE_ROOT_PATHS, SHOP_TREE_ROOT_PATH };
export { getTopicType };
export function getLabelledTopics(productTopics) {
    return productTopics?.flatMap(({ ancestors, name, path, id }) => {
        // Building the topic tree from the root down to current topic
        const topics = [
            ...(ancestors
                ?.sort(({ path: a }, { path: b }) => b.split("/").length - a.split("/").length)
                .reverse()
                ?.map(({ id, path, name }) => ({ id, name, path })) ?? []),
            { name, path, id },
        ];
        // Mapping the tropic tree to sanity category documents
        return topics.reduce((acc, cur, index) => {
            const parent = acc[index - 1];
            if (!cur.name)
                return acc;
            const { name, path, id } = cur;
            const topic = {
                id,
                name: name,
                path: path,
                pathLabel: [...acc.map(({ name }) => name), name].join("/"),
                topicType: getTopicType(path),
                parent,
            };
            return [...acc, topic];
        }, []);
    });
}
export function getTopicsFromDocumentRelatingItems(document) {
    const { topics: documentTopics, relatingItems } = document;
    const itemsTopics = relatingItems
        ?.filter((i) => i.__typename === "Product")
        .flatMap((product) => product.topics ?? []) ?? [];
    const topics = [...(documentTopics ?? []), ...itemsTopics];
    const deduplicatedTopics = new Map();
    topics.forEach((topic) => {
        if (!deduplicatedTopics.has(topic.path)) {
            deduplicatedTopics.set(topic.path, topic);
        }
    });
    return Array.from(deduplicatedTopics.values());
}
